export default __webpack_public_path__ + "static/media/arrow_hover.c05e2573.webp";